<script setup lang="ts">
import type { BasicPropsType, ResponsivePropsType } from '@/components/form/compositions/FieldsUtils'
import { BasicPropsDefaults, getFieldModel, ResponsivePropsDefaults } from '@/components/form/compositions/FieldsUtils'

withDefaults(defineProps<BasicPropsType & ResponsivePropsType>(), { ...BasicPropsDefaults, ...ResponsivePropsDefaults })
defineEmits(['input', 'paste'])
</script>

<template>
  <GsFormFieldsWrapper v-bind="$props">
    <template #default="{ form }">
      <el-input
        v-model.number="getFieldModel(form, apiFieldName).value"
        v-bind="$attrs"
        :placeholder="placeholder"
        @input="$emit('input', $event)"
        @paste="$emit('paste', $event)"
      />
    </template>
  </GsFormFieldsWrapper>
</template>

<style scoped lang="postcss">

</style>
